import type { ChangeEvent } from "react";

import { Input } from "../../input/input";
import { Label } from "../../Label";
import { Separator } from "../../Separator";

export interface NumberRangeFilter {
  type: "numberRange";
  min: number | null;
  max: number | null;
}

interface NumberRangeFilterInputProps {
  value: NumberRangeFilter | undefined;
  onChange: (value: NumberRangeFilter | undefined) => void;
}

export function NumberRangeFilterInput({
  value,
  onChange,
}: NumberRangeFilterInputProps) {
  const min = value?.min ?? null;
  const max = value?.max ?? null;

  const emit = (newMin: number | null, newMax: number | null) => {
    if (newMin === null && newMax === null) {
      onChange(undefined);
    } else {
      onChange({ type: "numberRange", min: newMin, max: newMax });
    }
  };

  return (
    <div className="flex items-end gap-2">
      <div className="flex flex-col gap-1">
        <Label className="text-label">Min</Label>
        <Input
          type="number"
          className="h-8 text-sm"
          placeholder="Min"
          value={min ?? ""}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            const parsed =
              e.target.value === "" ? null : Number(e.target.value);
            emit(parsed, max);
          }}
        />
      </div>
      <div className="pb-1.5">
        <Separator orientation="vertical" className="h-6" />
      </div>
      <div className="flex flex-col gap-1">
        <Label className="text-label">Max</Label>
        <Input
          type="number"
          className="h-8 text-sm"
          placeholder="Max"
          value={max ?? ""}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            const parsed =
              e.target.value === "" ? null : Number(e.target.value);
            emit(min, parsed);
          }}
        />
      </div>
    </div>
  );
}
